export const media = {
  portrait: "https://cdn.magicpatterns.com/uploads/gWDYAZZSXewAhbci1PDEJq/Gemini_Generated_Image_b1gtvmb1gtvmb1gt.png",
  heroAtmosphere: "https://cdn.magicpatterns.com/patterns/generated-images/6cd18bda-09c9-4ecb-b57b-e195ba789640.jpg",
  studioLight: "https://cdn.magicpatterns.com/patterns/generated-images/4df0d8cc-40f9-4744-82ab-5e157f6b59f0.jpg",
  materialStudy: "https://cdn.magicpatterns.com/patterns/generated-images/0bb827e3-edd0-4d15-997a-87923173ef13.jpg",
  ctaPlate: "https://cdn.magicpatterns.com/patterns/generated-images/568f3daa-fd27-457b-8200-24557e2fdbfd.jpg",
  archivePlate: "https://cdn.magicpatterns.com/patterns/generated-images/6bff2451-7340-48f1-b0a3-3e5209fb2fcd.jpg",
  motionPlate: "https://cdn.magicpatterns.com/patterns/generated-images/af6afee7-f788-49bc-a132-08e0f8ae4aa9.jpg",
  vfxPlate: "https://cdn.magicpatterns.com/patterns/generated-images/e595eab6-2d18-4e15-8fa6-c8241609fa63.jpg",
  chromePlate: "https://cdn.magicpatterns.com/patterns/generated-images/bef0fc20-c5cc-4f1c-abfb-ef22b7e8fe4c.jpg",
  particlePlate: "https://cdn.magicpatterns.com/patterns/generated-images/d84f5d61-41de-4c12-a98b-7a62c52a7cd4.jpg",
  /* Supplied artwork, one per capability in "What I do best". */
  cgiPlate: "https://cdn.magicpatterns.com/uploads/9Qsdh7YMH6DB2DPANg2KYt/image.png",
  characterPlate: "https://cdn.magicpatterns.com/uploads/44VEmRgcrW38YD3MgRiy8u/WhatsApp_Image_2026-08-21_at_23.29.01.jpg",
  motionPostPlate: "https://cdn.magicpatterns.com/uploads/6a6M34Tf4AuCreEkGoTf4N/image.png",
  commercialVfxPlate: "https://cdn.magicpatterns.com/uploads/2FbLo9KVcPBsie4B1UPC8Y/WhatsApp_Image_2026-08-23_at_13.42.14_(4).jpg",
  videoFormatPlate: "https://cdn.magicpatterns.com/uploads/5PcPSaFDChazZwDwjJQnPg/WhatsApp_Image_2026-08-23_at_13.42.14_(5).jpg",
  consultancyPlate: "https://cdn.magicpatterns.com/uploads/erZwTLN8MJAzbApjsgSoF1/WhatsApp_Image_2026-08-23_at_13.42.14.jpg",
  liveActionPlate: "https://cdn.magicpatterns.com/uploads/gjNtmX8QBUJo7hqN8hpdhZ/image.png",
  productDesignPlate: "https://cdn.magicpatterns.com/uploads/sttG61mF8KAFbUd4tY7qdi/WhatsApp_Image_2026-08-23_at_13.42.14_(1).jpg",
};

export const toolTicker = [
  "CINEMA 4D",
  "OCTANE RENDER",
  "AFTER EFFECTS",
  "AI WORKFLOWS",
  "COMPOSITING",
  "ROTOSCOPING",
  "CLEANPLATING",
  "MOTION DESIGN",
  "CGI",
  "POST-PRODUCTION",
];
